import { render, staticRenderFns } from "./ListagemModalDocumentosBotoesAcoes.vue?vue&type=template&id=1fd3dbfc&scoped=true"
import script from "./ListagemModalDocumentosBotoesAcoes.vue?vue&type=script&lang=js"
export * from "./ListagemModalDocumentosBotoesAcoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd3dbfc",
  null
  
)

export default component.exports